(function () {
  if (window.__bbSAB) return; window.__bbSAB = true;
  var CFG = window.__BB_SA || {};
  var SIZES = (CFG.sizes || []).map(function (s) { return String(s || '').trim(); }).filter(Boolean);
  var PRICE = CFG.price || '', CPRICE = CFG.cprice || '';
  var NEARBY_KM = 15;   // "nearby" radius; beyond it we offer the "looking far" region fallback

  // ── WhatsApp instead of Call (25 Sep 2026) ──
  // Function declarations on purpose: runTabs is started before the var assignments below run
  // (see the early return on a normal PDP), and a hoisted function is ready either way.
  function icWA() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#1a7f45" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 20.5l1.3-4.2A8.5 8.5 0 1 1 8 19.4z"/><path d="M9 8.6c0 3 2.4 5.9 5.6 6.4l1.1-1.3-1.7-.9-.8.8c-1-.4-1.8-1.2-2.2-2.2l.8-.8-.9-1.7z"/></svg>';
  }
  function fisLink(s, cls) {
    if (!s || !s.code || !CFG.fis) return '';
    var href = CFG.fis + '?item=' + encodeURIComponent(CFG.item || '') + '&store=' + encodeURIComponent(s.code)
      + '&src=' + (GOOGLE ? 'google' : 'pdp') + '&title=' + encodeURIComponent(CFG.title || '')
      // 11 Oct 2026: our visit id (bl-path.js), so the Traffic flow funnel can count "Sent WhatsApp enquiry" per visit
      + (function () { try { var v = sessionStorage.getItem('bl_vid'); return /^[a-z0-9]{20}$/.test(v || '') ? '&sid=' + v : ''; } catch (e) { return ''; } })();
    var who = String(s.name || s.area || 'this store').replace(/[<>"&]/g, '');
    var code = String(s.code).replace(/[^A-Za-z0-9]/g, '');
    return '<a class="' + cls + (fisSizeFor(code) ? '' : ' bb-fis-off') + '" data-fis="1" data-fis-store="' + code + '" href="' + href + '" target="_blank" rel="noopener nofollow"'
      + ' aria-label="Message ' + who + ' on WhatsApp" title="WhatsApp">' + icWA() + (/bb-sa-iconlink/.test(cls) ? '<span class="bb-sa-t">WhatsApp</span>' : '') + '</a>';
  }
  // ── NO SIZE, NO WHATSAPP (Suhail's rule, 25 Sep 2026; design approved from the mock) ──
  // Each store row shows THAT store's sizes as chips. He picks one there — which is how a size
  // sold out ONLINE (and so unpickable on the main page) can still reach a store that has it.
  // If he already picked a size on the main page and this store has it, that chip starts selected.
  // No size → the WhatsApp icon is greyed, and a tap says "Pick a size first" instead of opening.
  var FIS_SEL = {};     // store code → size he picked in that row
  var FIS_SIZES = {};   // store code → the sizes that store holds
  function fisChips(s) {
    if (!s || !s.code) return '';
    var have = Object.keys(s.sizes || {}).filter(function (k) { return s.sizes[k] > 0; });
    if (!have.length) return '';
    FIS_SIZES[s.code] = have.map(function (z) { return String(z).toUpperCase(); });
    return '<div class="bb-fis-ask">Tap your size to ask on WhatsApp</div><div class="bb-fis-chips" data-fis-store="' + String(s.code).replace(/[^A-Za-z0-9]/g, '') + '">' +
      have.map(function (z) { var zz = String(z).replace(/[<>"&]/g, ''); return '<button type="button" class="bb-fis-chip" data-fis-chip="' + zz + '" aria-pressed="false">' + zz + '</button>'; }).join('') +
      '</div><div class="bb-fis-hint" data-fis-hint="' + String(s.code).replace(/[^A-Za-z0-9]/g, '') + '" hidden>Pick a size first</div>';
  }
  function fisSizeFor(code) {
    if (FIS_SEL[code]) return FIS_SEL[code];
    var m = selectedSize();
    return (m && FIS_SIZES[code] && FIS_SIZES[code].indexOf(m) >= 0) ? m : null;
  }
  // Paint every row: which chip is on, and whether its WhatsApp icon is live.
  function fisRefresh() {
    document.querySelectorAll('[data-fis-store]').forEach(function (g) {
      var code = g.getAttribute('data-fis-store'), cur = fisSizeFor(code);
      g.querySelectorAll('[data-fis-chip]').forEach(function (c) {
        var on = String(c.getAttribute('data-fis-chip')).toUpperCase() === cur;
        c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    document.querySelectorAll('a[data-fis]').forEach(function (a) {
      var szNow = fisSizeFor(a.getAttribute('data-fis-store'));
      a.classList.toggle('bb-fis-off', !szNow);
      // the big Google-landing button names the size (11 Oct 2026)
      var lb = a.querySelector('[data-fis-label]');
      if (lb) lb.textContent = szNow ? 'Ask about size ' + szNow : 'Pick a size to ask on WhatsApp';
    });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // a size chip in a store row
    var chip = e.target.closest('[data-fis-chip]');
    if (chip) {
      var g = chip.closest('[data-fis-store]'); if (!g) return;
      var code = g.getAttribute('data-fis-store');
      FIS_SEL[code] = String(chip.getAttribute('data-fis-chip')).toUpperCase();
      var h = document.querySelector('[data-fis-hint="' + code + '"]'); if (h) h.hidden = true;
      fisRefresh(); return;
    }
    // a size picked on the main page: rows that hold it follow, unless he chose in the row himself
    if (e.target.closest('[data-bpdp-ab-size], .bpdp-size-cell')) { setTimeout(fisRefresh, 60); return; }
    // the WhatsApp icon
    var a = e.target.closest('a[data-fis]');
    if (!a) return;
    var code2 = a.getAttribute('data-fis-store'), sz = fisSizeFor(code2);
    if (!sz) {
      e.preventDefault(); e.stopPropagation();
      var hint = document.querySelector('[data-fis-hint="' + code2 + '"]');
      if (hint) { hint.hidden = false; try { hint.scrollIntoView({ block: 'nearest' }); } catch (_) {} }
      return;
    }
    try {
      var u = new URL(a.getAttribute('href'), location.origin);
      u.searchParams.set('size', sz);
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) { /* the link still opens WhatsApp */ }
  }, true);

  // ── ITEM INTEREST COUNTER (25 Sep 2026) ──
  // Adds 1 to this item's count for the day at bb-chat /apps/chat/cnt: a page open (view), an
  // Add to cart with a size chosen (atc), and Find in Store (the button, or the In store tab tapped
  // by a person). Sends ONLY the event, the item code and the source — no cookie, no id — so it
  // counts every visitor, not just the ~1 in 8 who accept cookies. Once per event per page load.
  var CNT_SENT = {};
  function cntOnce(ev) {
    if (CNT_SENT[ev] || !CFG.item) return;
    CNT_SENT[ev] = 1;
    try {
      var b = new URLSearchParams({ e: ev, item: String(CFG.item), src: 'pdp' });
      // With the view only: which product this is (id, handle, type) — describes the product, not
      // the visitor — so the report can split by category and match orders.
      if (ev === 'view') { b.set('pid', String(CFG.pid || '')); b.set('h', String(CFG.handle || '')); b.set('cat', String(CFG.ptype || '')); }
      if (!(navigator.sendBeacon && navigator.sendBeacon('/apps/chat/cnt', b)))
        fetch('/apps/chat/cnt', { method: 'POST', body: b, keepalive: true }).catch(function () {});
    } catch (err) { /* a lost count never touches the page */ }
  }
  cntOnce('view');
  // Sold-out size taps (25 Sep 2026, the "Tapped only" row on Stock needed): a tap on a size that
  // is sold out online, which opens Notify Me. Sent with the size; once per size per page load.
  // Most people who tap close Notify Me without signing up — this is the demand they leave behind.
  var OOS_SENT = {};
  function cntOos(size) {
    size = String(size || '').trim().toUpperCase();
    if (!size || OOS_SENT[size] || !CFG.item) return;
    OOS_SENT[size] = 1;
    try {
      var b = new URLSearchParams({ e: 'oos', item: String(CFG.item), src: 'pdp', size: size });
      if (!(navigator.sendBeacon && navigator.sendBeacon('/apps/chat/cnt', b)))
        fetch('/apps/chat/cnt', { method: 'POST', body: b, keepalive: true }).catch(function () {});
    } catch (err) { /* a lost count never touches the page */ }
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var oos = e.target.closest('[data-bpdp-ab-oos]');
    if (oos) cntOos(oos.getAttribute('data-size'));
    if (e.target.closest('[data-bpdp-ab-add]') && selectedSize()) cntOnce('atc');
    // The Find in Store button clicks the In store tab itself; that click is not trusted, so it
    // is not counted twice.
    if (e.target.closest('[data-bpdp-find-store]') || (e.isTrusted && e.target.closest('.bb-t-tab[data-t="ins"]'))) cntOnce('fis');
  }, true);

  function urlCode() {
    try {
      var q = new URLSearchParams(location.search);
      var c = (q.get('store_code') || '').trim().toUpperCase();
      if (c) return c;
      // 11 Oct 2026: Google's store-stock tap (the Merchant Center file links with ?store=XX).
      var g = (q.get('store') || '').trim().toUpperCase();
      if (/^[A-Z0-9]{2,3}$/.test(g)) { GOOGLE = true; return g; }
      // #3: Google Shopping links can't always append store_code, so the store rides in utm_content
      // (2-char uppercase, e.g. XK). Accept it as a store_code fallback.
      var uc = (q.get('utm_content') || '').trim().toUpperCase();
      if (/^[A-Z]{2}$/.test(uc)) return uc;
      return '';
    } catch (e) { return ''; }
  }
  var GOOGLE = false;                // set by urlCode() when the store came from Google (?store=)
  var CODE = urlCode();              // store from the CURRENT URL only — no session persistence
  // 11 Oct 2026: tell Marketing → Find in Store that a shopper arrived from Google's "in stock nearby", and whether
  // it was a PAID click (Google's ad click code in the URL; Google rewrites the link tags on paid clicks).
  if (GOOGLE && CFG.item) {
    try {
      var _q = new URLSearchParams(location.search), _vid = sessionStorage.getItem('bl_vid') || '';
      var _paid = (_q.get('gclid') || _q.get('gbraid') || _q.get('wbraid')) ? '1' : '0';
      var _land = function () { var v = sessionStorage.getItem('bl_vid') || ''; if (!/^[a-z0-9]{20}$/.test(v)) return; (new Image()).src = '/apps/chat/fis/land?store=' + encodeURIComponent(CODE) + '&item=' + encodeURIComponent(CFG.item) + '&vid=' + v + '&paid=' + _paid; };
      if (_vid) _land(); else setTimeout(_land, 1500);   // bl-path.js may not have made the visit id yet
    } catch (e) {}
  }
  var AD_CODE = CODE;                // the original store from the ad — never changes
  if (!CFG.item) return;
  if (!CODE) { onReady(runTabs); return; }   // NORMAL PDP (no store_code) → Delivery | In store tabs

  var root = document.getElementById('bb-sa');
  if (!root) return;
  var box = root.querySelector('[data-sa-instore]');
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
  var _toastEl = null, _toastT = null;
  function toast(msg) {
    if (!_toastEl) { _toastEl = document.createElement('div'); _toastEl.className = 'bb-sa-toast'; document.body.appendChild(_toastEl); }
    _toastEl.textContent = msg; _toastEl.classList.add('show');
    if (_toastT) clearTimeout(_toastT);
    _toastT = setTimeout(function () { _toastEl.classList.remove('show'); }, 2000);
  }

  var geo = null, geoDenied = false, lastData = null;
  var nearbyOpen = false, showRegion = false, geoBusy = false;
  var picked = null;   // a nearby store the shopper chose to view as the main card (client-side swap)

  var IC_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  var IC_DIR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';
  var IC_CALL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.8 9.8a16 16 0 0 0 6 6l1.4-1.3a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z"/></svg>';

  function openNow() {
    try { var ist = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })); var m = ist.getHours() * 60 + ist.getMinutes(); return m >= 630 && m < 1290; }
    catch (e) { return true; }
  }
  function fullAddr(s) { var a = s.address || ''; if (s.pincode) a += (a ? ' - ' : '') + s.pincode; return a || s.name || ''; }
  function selectedSize() {
    // ⚠ 25 Sep 2026: every product template renders main-product-abtest-c, whose size pills are
    // [data-bpdp-ab-size] and get .is-selected. The .bpdp-size-cell selectors below never matched
    // on this design, so the chosen size was never seen. Read the pill first.
    var pill = document.querySelector('[data-bpdp-ab-size].is-selected');
    if (pill) { var ps = (pill.getAttribute('data-size') || '').trim().toUpperCase(); if (ps) return ps; }
    var el = document.querySelector('.bpdp-size-cell.is-selected, .bpdp-size-cell.is-active, .bpdp-size-cell.selected, .bpdp-size-cell[aria-pressed="true"], .bpdp-size-cell[aria-selected="true"]');
    if (el) { var t = (el.getAttribute('data-size') || el.textContent || '').trim().toUpperCase(); if (t) return t.split(/\s+/)[0]; }
    return null;
  }
  function dirHref(s) { if (s.lat != null && s.lng != null) return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng; return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((s.name || '') + ' ' + fullAddr(s)); }
  // Price is intentionally NOT shown on the card — the PDP's native "MRP … (Inclusive of all taxes)"
  // block already shows it right above, so repeating it here would be redundant. (PRICE stays in
  // __BB_SA for crawlability but is not rendered.)
  // EXCEPT from Google (11 Oct 2026): Google checks that the page shows the price it was sent for the
  // store, which is the MRP, so the card says it plainly even when the website price above is lower.
  function priceHtml() {
    if (!GOOGLE) return '';
    var m = lastData && lastData.item && Number(lastData.item.mrp);
    var txt = m > 0 ? '₹' + m.toLocaleString('en-IN') : (CFG.cprice || CFG.price || '');
    return txt ? '<div class="bb-sa-sprice">Price in store <b>' + esc(txt) + '</b></div>' : '';
  }
  // "Basics Life. Chennai, Phoenix Marketcity" → "Basics Life, Phoenix Marketcity" (how Google lists it)
  function shortName(s) { return String((s && (s.name || s.area)) || '').replace(/^Basics Life\.?\s*[^,]*,\s*/i, 'Basics Life, '); }
  function waButton(s) {
    if (!s || !s.code) return '';
    var a = fisLink(s, 'bb-sa-wabtn');
    // same link as the icon, with a label; fisRefresh() writes "Ask about size M"
    return a.replace(/>[^<]*<svg/, '><svg').replace(/<\/a>$/, '<span data-fis-label>Pick a size to ask on WhatsApp</span></a>');
  }
  function statusHtml(s, selSize) {
    var out;
    if (selSize) { var ok = (s.sizes && s.sizes[selSize] > 0); out = 'Size ' + esc(selSize) + (ok ? ' <span class="in">in stock</span>' : ' <span class="out">out of stock</span>'); }
    else { var have = Object.keys(s.sizes || {}).filter(function (k) { return s.sizes[k] > 0; }); out = have.length ? '<span class="in">' + esc(have.join(', ')) + ' in stock</span>' : '<span class="in">In stock</span>'; }
    if (geo && s.km != null) out += ' · ' + s.km + ' km away';
    return out;
  }

  // `code` given → the in-stock chips double as the WhatsApp size pick for this store (25 Sep 2026).
  function sizeChips(sizes, code) {
    sizes = sizes || {};
    var list = SIZES.length ? SIZES : Object.keys(sizes);
    var c = code ? String(code).replace(/[^A-Za-z0-9]/g, '') : '';
    if (c) FIS_SIZES[c] = list.filter(function (s) { return (sizes[String(s).toUpperCase()] || sizes[s] || 0) > 0; }).map(function (s) { return String(s).toUpperCase(); });
    return '<div class="bb-sa-slbl">Available Sizes</div><div class="bb-sa-sizes"' + (c ? ' data-fis-store="' + c + '"' : '') + '>' +
      list.map(function (s) { var has = (sizes[String(s).toUpperCase()] || sizes[s] || 0) > 0; return '<span class="bb-sa-sz' + (has ? '' : ' oos') + '" data-sz="' + esc(s) + '" data-in="' + (has ? '1' : '0') + '"' + (has && c ? ' data-fis-chip="' + esc(s) + '"' : '') + '>' + esc(s) + '</span>'; }).join('') + '</div>' +
      (c ? '<div class="bb-fis-hint" data-fis-hint="' + c + '" hidden>Pick a size first</div>' : '');
  }
  function mainCard(s) {
    var oc = openNow();
    // #5: no per-store hours in the data → open/closed on the chain-wide window only, drop the specific time.
    var meta = (oc ? 'Open now' : 'Closed now');
    if (geo && s.km != null) meta += ' · ' + s.km + ' km away';
    var tel = s.phone ? String(s.phone).replace(/[^\d+]/g, '') : '';
    var links = '<a class="bb-sa-iconlink" href="' + esc(dirHref(s)) + '" target="_blank" rel="noopener" aria-label="Directions" title="Directions">' + IC_DIR + '<span class="bb-sa-t">Directions</span></a>' +
      (GOOGLE ? '' : fisLink(s, 'bb-sa-iconlink'));
    // From Google: the store is the one the shopper tapped, so the card names it, shows the store
    // price, and the WhatsApp ask is a big button under the sizes (mock, 11 Oct 2026).
    var isAdStore = GOOGLE && String(s.code).toUpperCase() === CODE;
    return '<div class="bb-sa-card' + (GOOGLE ? ' bb-sa-g' : '') + '">' +
      '<div class="bb-sa-hd"><span class="bb-sa-dot"></span>' + (isAdStore ? 'In stock at ' + esc(shortName(s)) : 'In stock near you') + '</div>' +
      '<hr class="bb-sa-hdline">' +
      (isAdStore ? '' : '<div class="bb-sa-name">' + esc(GOOGLE ? shortName(s) : (s.name || s.area)) + '</div>') +
      '<div class="bb-sa-addr">' + esc(fullAddr(s)) + '</div>' +
      priceHtml() +
      '<div class="bb-sa-row"><span class="bb-sa-meta' + (oc ? '' : ' closed') + '">' + esc(meta) + '</span><span class="bb-sa-links">' + links + '</span></div>' +
      '<hr class="bb-sa-dash">' + sizeChips(s.sizes, s.code) +
      (GOOGLE ? waButton(s) : '') +
    '</div>';
  }
  // "not stocked at the ad's store, but N feed store(s) have it" — list them straight away (no geo gate)
  function notHereCard(storeName, list) {
    var rows = list.map(function (s) { return storeRow(s, selectedSize(), true); }).join('');
    return '<div class="bb-sa-card">' +
      '<div class="bb-sa-hd"><span class="bb-sa-dot" style="background:#a2543a;box-shadow:0 0 0 3px #f0d9d1"></span>Not in stock here</div>' +
      '<hr class="bb-sa-hdline">' +
      '<div class="bb-sa-addr">Not available at <b>' + esc(storeName) + '</b> right now.' + (PRICE ? '' : '') + '</div>' +
      priceHtml() +
      (rows ? '<hr class="bb-sa-dash"><div class="bb-sa-slbl">Available at</div><div class="bb-sa-nwrap">' + rows + '</div>' : '') +
    '</div>';
  }
  function storeRow(s, selSize, withView) {
    var tel = s.phone ? String(s.phone).replace(/[^\d+]/g, '') : '';
    var acts = (withView ? '<button type="button" class="bb-sa-viewbtn" data-view="' + esc(s.code) + '">View</button>' : '') +
      '<a class="bb-sa-iconlink sm" href="' + esc(dirHref(s)) + '" target="_blank" rel="noopener" aria-label="Directions" title="Directions">' + IC_DIR + '<span class="bb-sa-t">Directions</span></a>' +
      fisLink(s, 'bb-sa-iconlink sm');
    return '<div class="bb-sa-nb"><span class="pin">' + IC_PIN + '</span>' +
      '<div class="txt"><div class="nm">' + esc(s.name || ((s.area || '') + ' Store')) + '</div><div class="st">' + statusHtml(s, selSize) + '</div>' + fisChips(s) + '</div>' +
      '<span class="bb-sa-nb-acts">' + acts + '</span></div>';
  }

  // the store shown in the main card: a nearby store the shopper picked, else the ad's store
  function focusStore() { return picked || (lastData && lastData.here) || null; }
  // every OTHER store that holds the item (the ad's store + all nearby), minus the focused one, deduped
  function otherStores() {
    var f = focusStore(); var fcode = f ? f.code : CODE;
    var list = [];
    if (lastData && lastData.here && (!f || lastData.here.code !== fcode)) list.push(lastData.here);
    ((lastData && lastData.nearby) || []).forEach(function (s) { if (s.code !== fcode) list.push(s); });
    var seen = {}; return list.filter(function (s) { if (seen[s.code]) return false; seen[s.code] = 1; return true; });
  }
  function nearbyHtml() {
    var pool = otherStores();
    if (!pool.length) return '';   // no other store holds it → no "nearby" affordance
    if (!nearbyOpen) {
      return '<button type="button" class="bb-sa-nearbtn" data-open-near>' + IC_PIN + 'Click here to view nearby available stores</button>';
    }
    if (geoBusy) return '<div class="bb-sa-spin">Finding stores near you…</div>';
    if (geoDenied || !geo) {
      // no location yet — still show the feed stores that have it (selectable), just without distance
      return '<div class="bb-sa-nwrap"><div class="bb-sa-nhd">Other stores with this item</div>' +
        pool.slice(0, 3).map(function (s) { return storeRow(s, selectedSize(), true); }).join('') + '</div>';
    }
    var selSize = selectedSize();
    var within = pool.filter(function (s) { return s.km != null && s.km <= NEARBY_KM; }).slice(0, 3);
    if (within.length) {
      return '<div class="bb-sa-nwrap"><div class="bb-sa-nhd">Available near you</div>' + within.map(function (s) { return storeRow(s, selSize, true); }).join('') + '</div>';
    }
    if (!showRegion) {
      return '<div class="bb-sa-nwrap"><div class="bb-sa-far"><p>No nearby store available — looking far from your location?</p><button type="button" class="bb-sa-nearbtn" data-show-region>' + IC_PIN + 'Show nearest stores in your region</button></div></div>';
    }
    var region = pool.slice(0, 3);
    return '<div class="bb-sa-nwrap"><div class="bb-sa-nhd">Nearest stores</div>' + region.map(function (s) { return storeRow(s, selSize, true); }).join('') + '</div>';
  }

  function render() {
    var d = lastData; if (!d) return;
    var focus = focusStore();
    if (focus) {
      box.innerHTML = mainCard(focus) + nearbyHtml();
    } else {
      var n = d.totalStores || 0;
      var storeName = (d.store && (GOOGLE ? shortName(d.store) : (d.store.name || d.store.area))) || CODE;
      if (n) {
        box.innerHTML = notHereCard(storeName, otherStores().slice(0, 3));
      } else {
        box.innerHTML = '<div class="bb-sa-card"><div class="bb-sa-hd"><span class="bb-sa-dot" style="background:#a2543a;box-shadow:0 0 0 3px #f0d9d1"></span>Out of stock</div>' +
          '<div class="bb-sa-addr" style="color:#6b6b6b">This item isn’t in stock at any BASICS store right now.</div>' + priceHtml() + '</div>';
      }
    }
    wire();
    fisRefresh();   // rows are new: grey or live each WhatsApp icon by its size
  }
  function wire() {
    var ob = box.querySelector('[data-open-near]'); if (ob) ob.onclick = function () { nearbyOpen = true; showRegion = false; askGeo(); };
    var rg = box.querySelector('[data-retry-geo]'); if (rg) rg.onclick = function () { geoDenied = false; askGeo(); };
    var sr = box.querySelector('[data-show-region]'); if (sr) sr.onclick = function () { showRegion = true; render(); };
    box.querySelectorAll('[data-view]').forEach(function (b) {
      b.onclick = function () {
        var c = b.getAttribute('data-view'); if (!c) return;
        var all = [].concat((lastData && lastData.here) ? [lastData.here] : [], (lastData && lastData.nearby) || []);
        var st = all.filter(function (s) { return s && s.code === c; })[0];
        if (!st) return;
        // swap the picked store into the main card using data we already have (no re-fetch → a
        // general-stock store never shows a false "not in the feed"); picking the ad's store = reset
        picked = (lastData.here && st.code === lastData.here.code) ? null : st;
        try { root.scrollIntoView({ block: 'nearest' }); } catch (e) {}
        render();
      };
    });
  }

  function api(extra) { return fetch(CFG.worker + '/api/item.json?item=' + encodeURIComponent(CFG.item) + '&code=' + encodeURIComponent(CODE) + (extra || '')).then(function (r) { return r.json(); }); }
  function load() { api(geo ? ('&lat=' + geo.lat + '&lng=' + geo.lng) : '').then(function (d) { lastData = d; render(); }).catch(function () { box.innerHTML = '<div class="bb-sa-card"><div class="bb-sa-addr">Couldn’t load store stock. Please try again.</div></div>'; }); }
  function askGeo() {
    if (geo) { load(); return; }
    if (!navigator.geolocation) { geoDenied = true; render(); return; }
    geoBusy = true; render();
    navigator.geolocation.getCurrentPosition(
      function (pos) { geoBusy = false; geo = { lat: +pos.coords.latitude.toFixed(5), lng: +pos.coords.longitude.toFixed(5) }; load(); },
      function () { geoBusy = false; geoDenied = true; render(); },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  // Pick a VISIBLE, non-modal anchor high in the buy box. The FIRST .bpdp-size-grid in the DOM is
  // inside the hidden "SELECT SIZE" modal (#bpdp-modal-sizes) — inserting there hides the card, so
  // we skip modal/hidden copies. The price line (.bpdp-price-line) is unique + server-rendered.
  // The price amount carries a stable, unique id (#bpdp-price-cur) in EVERY PDP variant (basics + the
  // A/B-test variant cookieless visitors get). Anchor off it — with NO offsetParent gate, so the
  // variant's JS hydration can't momentarily hide it and make us fall to a lower anchor — and drop the
  // card right AFTER the whole price ROW (a sibling in the buy-box column, never inside the flex row,
  // which would reflow the size pills).
  function priceRow() {
    var cur = document.getElementById('bpdp-price-cur');
    if (cur) { var pl = cur.closest('.bpdp-price-line'); if (pl && !pl.closest('.bpdp-modal, [data-bpdp-modal]')) return pl; }
    var pls = document.querySelectorAll('.bpdp-price-line');
    for (var i = 0; i < pls.length; i++) { if (!pls[i].closest('.bpdp-modal, [data-bpdp-modal]')) return pls[i]; }
    return null;
  }
  function fallbackAnchor() {
    var grids = document.querySelectorAll('.bpdp-size-grid');
    for (var i = 0; i < grids.length; i++) {
      var g = grids[i];
      if (!g.closest('.bpdp-modal, [data-bpdp-modal]') && g.offsetParent !== null) return g;  // NOT the hidden size modal
    }
    return document.querySelector('.bpdp-pincode') || document.querySelector('[data-bpdp-pincode]');
  }
  function place() {
    // Suhail's PDP (C): its JS builds the size section (.bpdp-absize) and moves the COD/benefits trust
    // row above it — inserting that block right where a static slot would sit. So anchor the card just
    // BEFORE .bpdp-absize → it lands below the benefits row and above the Size chart; the self-healing
    // observer keeps it there. Falls through on variants without .bpdp-absize to the price-row anchor.
    var abs = document.querySelector('.bpdp-absize');
    if (abs && abs.offsetParent !== null && !abs.closest('.bpdp-modal, [data-bpdp-modal]')) {
      if (!(root.parentNode === abs.parentNode && root.nextSibling === abs)) abs.parentNode.insertBefore(root, abs);
      root.hidden = false; return true;
    }
    var pl = priceRow();
    if (pl) {
      if (!(root.parentNode === pl.parentNode && pl.nextSibling === root)) pl.parentNode.insertBefore(root, pl.nextSibling);
      root.hidden = false; return true;
    }
    var fa = fallbackAnchor();
    if (fa) {
      if (!(root.parentNode === fa.parentNode && root.nextSibling === fa)) fa.parentNode.insertBefore(root, fa);
      root.hidden = false; return true;
    }
    return false;
  }
  function mount() {
    if (!place() && (mount._n = (mount._n || 0) + 1) < 50) { setTimeout(mount, 150); return; }
    // keep the card anchored right under the price even if the custom PDP re-renders / re-orders the
    // buy box (Suhail's PDP builds sizes/chips via JS and can move our card to the bottom). place() is
    // idempotent — it only re-inserts when the card isn't already the price row's next sibling.
    try {
      var mo = new MutationObserver(function () { place(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    } catch (e) {}
    box.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.bb-sa-sz') : null;
      if (!chip) return;
      var sz = chip.getAttribute('data-sz');
      var isin = chip.getAttribute('data-in') === '1';
      toast(isin ? ('Size ' + sz + ' is available in store') : ('Size ' + sz + ' is not available in this store'));
    });
    load();   // main card only; nearby waits for the user to click (no location prompt on landing)
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.bpdp-size-cell, [data-bpdp-pick-size], [data-bpdp-size]')) setTimeout(render, 60);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();

  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  // ===== NORMAL PDP (no store_code): "Delivery | In store" tabs. Self-contained. =====
  function runTabs() {
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
    var W = CFG.worker, ITEM = CFG.item, STORES = CFG.stores || 120;
    var IC_LOC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3.2"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>';
    var IC_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="4" width="13" height="11" rx="1"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>';
    var IC_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
    var IC_PINF = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';
    var IC_CALL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.8 9.8a16 16 0 0 0 6 6l1.4-1.3a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z"/></svg>';
    function fullAddr(s) { var a = s.address || ''; if (s.pincode) a += (a ? ' - ' : '') + s.pincode; return a || s.name || ''; }
    function dirHref(s) { if (s.lat != null && s.lng != null) return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng; return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((s.name || '') + ' ' + fullAddr(s)); }
    // ── 14 Oct 2026: SIZE FIRST, then where he is (never guessed), then the decision ladder ──
    var FAR_KM = 25;                                   // "close by" for stores outside his city (his ruling)
    var HAS_SIZES = SIZES.length > 0;                  // belts, bags…: no size step
    var ONLINE = {}; (CFG.online || []).forEach(function (z) { z = String(z || '').trim().toUpperCase(); if (z) ONLINE[z] = 1; });
    // Store hours until bl-retail sends s.hours (bl-store-directory, 14 Oct 2026): these mall stores keep 11 am – 10 pm,
    // every other store 10:30 am – 9:30 pm.
    var MALL_11 = ',OM,HK,YN,HL,FS,PH,H6,HF,VI,HE,KU,PQ,VB,UQ,H2,EM,TK,RR,K2,NX,UV,WS,WZ,';
    var fSize = null, fLoc = null, fBusy = false, fData = null;   // fLoc = {lat,lng} or {pin}
    function upSize(z) { return String(z || '').trim().toUpperCase(); }
    function onlineHas(z) { return HAS_SIZES ? !!ONLINE[upSize(z)] : !!CFG.onlineAny; }
    function storeHas(s, z) { if (!HAS_SIZES) return (s.qty || 0) > 0 || Object.keys(s.sizes || {}).some(function (k) { return s.sizes[k] > 0; }); return ((s.sizes || {})[upSize(z)] || 0) > 0; }
    function storeLeft(s, z) { if (!HAS_SIZES) return s.qty || 0; return (s.sizes || {})[upSize(z)] || 0; }
    function shortNm(s) { return String(s.name || s.area || 'Store').replace(/^Basics Life\.?\s*[^,]*,\s*/i, ''); }
    // "10:30 AM – 9:30 PM" → [630, 1290] minutes
    function hoursOf(s) {
      var h = String(s.hours || ''), m = h.match(/(\d{1,2})(?::(\d\d))?\s*(AM|PM)\s*[–\-]\s*(\d{1,2})(?::(\d\d))?\s*(AM|PM)/i);
      function mins(hh, mm, ap) { hh = +hh % 12; if (/pm/i.test(ap)) hh += 12; return hh * 60 + (+mm || 0); }
      if (m) return [mins(m[1], m[2], m[3]), mins(m[4], m[5], m[6])];
      return MALL_11.indexOf(',' + String(s.code || '').toUpperCase() + ',') >= 0 ? [660, 1320] : [630, 1290];
    }
    function clock(t) { var h = Math.floor(t / 60), mm = t % 60, ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ' ' + ap; }
    function istNow() { try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })); } catch (e) { return new Date(); } }
    function openLine(s) {
      var hr = hoursOf(s), n = istNow(), m = n.getHours() * 60 + n.getMinutes();
      if (m >= hr[0] && m < hr[1]) return 'Open till ' + clock(hr[1]);
      return '<b class="closed">Closed now · opens ' + (m >= hr[1] ? 'tomorrow ' : '') + clock(hr[0]) + '</b>';
    }
    // whole India-days between the store's stock date and today
    function daysOld(iso) {
      if (!iso) return null;
      var t = Date.parse(iso); if (isNaN(t)) return null;
      var day = function (ms) { return Math.floor((ms + 330 * 60000) / 86400000); };
      return Math.max(0, day(Date.now()) - day(t));
    }
    function storeCard(s, z, outside) {
      var code = String(s.code || '').replace(/[^A-Za-z0-9]/g, '');
      FIS_SEL[code] = HAS_SIZES ? upSize(z) : 'ONE SIZE';   // the WhatsApp text names his size
      var d = daysOld(s.stockAt || (fData && fData.stockAsOf)), left = storeLeft(s, z);
      var km = s.km != null ? ((fLoc && fLoc.pin ? 'about ' : '') + s.km + ' km') : '';
      var notes = '';
      // his ruling 14 Oct: every card nudges a WhatsApp (that's where we learn who he is); no "keep it for you"
      notes = '<div class="bb-f-note">' + (left === 1 ? 'Only 1 left. ' : '') + 'WhatsApp the store for directions and to check it’s in stock right now.</div>';
      return '<div class="bb-f-card"><div class="bb-f-top">' + esc(shortNm(s)) + '<span>' + esc(km) + '</span></div>' +
        '<div class="bb-f-meta">' + (outside ? 'Outside ' + esc(outside) + ' · ' : '') + openLine(s) + (d === 0 ? ' · Stock updated today' : d === 1 ? ' · Stock updated yesterday' : d > 1 ? ' · Stock updated ' + d + ' days ago' : '') + '</div>' +
        '<div class="bb-f-has">✓ Has ' + (HAS_SIZES ? 'size ' + esc(upSize(z)) : 'it') + '</div>' + notes +
        '<div class="bb-f-acts"><a class="bb-sa-iconlink sm" href="' + esc(dirHref(s)) + '" target="_blank" rel="noopener" aria-label="Directions" title="Directions">' + IC_PINF + '<span class="bb-sa-t">Directions</span></a>' +
        fisLink(s, 'bb-sa-iconlink sm') + '</div></div>';
    }
    function onlineLine(z) {
      if (!onlineHas(z)) return '';
      return '<div class="bb-f-online">Rather have it delivered? <button type="button" data-f-buy="' + esc(upSize(z)) + '">Buy ' + (HAS_SIZES ? 'size ' + esc(upSize(z)) + ' ' : '') + 'online</button></div>';
    }
    // nothing in a store near him: online, else Notify me
    function onlineOrNotify(z, head, sub) {
      var zz = HAS_SIZES ? 'Size ' + esc(upSize(z)) : 'It';
      var out = '<div class="bb-f-msg warn"><b>' + head + '</b>' + (sub ? '<small>' + sub + '</small>' : '') + '</div>';
      if (onlineHas(z)) return out + '<div class="bb-f-msg ok"><b>' + zz + ' is available online.</b><small>Free delivery · Cash on delivery · 30-day returns</small></div>' +
        '<button type="button" class="bb-f-btn main" data-f-add="' + esc(upSize(z)) + '">Add ' + (HAS_SIZES ? esc(upSize(z)) + ' ' : '') + 'to bag</button>';
      if (!HAS_SIZES) return out;
      return out + '<button type="button" class="bb-f-btn main" data-f-notify="' + esc(upSize(z)) + '">Notify me when ' + esc(upSize(z)) + ' is back</button>' +
        '<button type="button" class="bb-f-btn ghost" data-f-sizes>See other sizes</button>';
    }
    function decide(d, z) {
      var all = (d.nearby || []).filter(function (s) { return s && s.code; });
      var have = all.filter(function (s) { return storeHas(s, z); }).sort(function (a, b) { return (a.km == null ? 1e9 : a.km) - (b.km == null ? 1e9 : b.km); });
      var zt = HAS_SIZES ? 'Size ' + esc(upSize(z)) : 'This';
      // his city = the city of the nearest store of ours (any stock), from bl-retail's nearestAny; until it sends
      // that, the nearest store that holds this item
      var near = d.nearestAny || all.slice().sort(function (a, b) { return (a.km == null ? 1e9 : a.km) - (b.km == null ? 1e9 : b.km); })[0] || null;
      if (!near || near.km == null || near.km > FAR_KM) {
        return onlineOrNotify(z, d.nearestAny ? "We don't have a store near you yet." : 'None of our stores near you has this right now.', '');
      }
      var city = near.city || '';
      var inCity = have.filter(function (s) { return city && s.city === city; });
      if (inCity.length) {
        return '<p class="bb-f-head"><b>' + inCity.length + ' store' + (inCity.length > 1 ? 's' : '') + ' in ' + esc(city) + '</b> ' + (inCity.length > 1 ? 'have' : 'has') + ' ' + (HAS_SIZES ? 'size ' + esc(upSize(z)) : 'it') + '</p>' +
          '<div class="bb-f-list">' + inCity.slice(0, 6).map(function (s) { return storeCard(s, z, ''); }).join('') + '</div>' + onlineLine(z);
      }
      var close = have.filter(function (s) { return s.km != null && s.km <= FAR_KM; });
      var notHere = zt + " isn't in our " + esc(city || 'nearby') + ' stores right now.';
      if (close.length) {
        return '<div class="bb-f-msg warn"><b>' + notHere + '</b><small>But a store close by has it:</small></div>' +
          '<div class="bb-f-list">' + close.slice(0, 4).map(function (s) { return storeCard(s, z, s.city && s.city !== city ? s.city : ''); }).join('') + '</div>' + onlineLine(z);
      }
      return onlineOrNotify(z, notHere + (onlineHas(z) || !HAS_SIZES ? '' : " And it's sold out online."), 'We checked our ' + esc(city) + ' stores and every store within ' + FAR_KM + ' km.');
    }

    // #4: Google Shopping / ads clicks (gclid or srsltid in the URL) → default to the In store tab.
    var adClick = false;
    try { var _q = new URLSearchParams(location.search); adClick = !!(_q.get('gclid') || _q.get('srsltid')); } catch (e) {}

    var tries = 0;
    (function build() {
      var pin = document.querySelector('.bpdp-pincode') || document.querySelector('[data-bpdp-pincode]');
      if (!pin && ++tries < 50) return setTimeout(build, 150);   // wait for the delivery widget to render
      var wrap = document.getElementById('bb-sa');
      if (!wrap) return;
      wrap.innerHTML =
        '<div class="bb-t"><div class="bb-t-hd">' +
          '<button type="button" class="bb-t-tab' + (adClick ? '' : ' is-on') + '" data-t="del">' + IC_TRUCK + 'Delivery</button>' +
          '<button type="button" class="bb-t-tab' + (adClick ? ' is-on' : '') + '" data-t="ins">' + IC_PIN + 'In store</button>' +
        '</div>' +
        '<div class="bb-t-pane" data-p="del"' + (adClick ? ' hidden' : '') + '></div>' +
        '<div class="bb-t-pane" data-p="ins"' + (adClick ? '' : ' hidden') + '>' +
          '<p class="bb-t-lead">See which of our <b>' + STORES + '</b> stores has ' + (HAS_SIZES ? 'your size' : 'this') + '.</p>' +
          (HAS_SIZES ? '<p class="bb-f-q">Which size do you want?</p><div class="bb-f-sizes">' +
            SIZES.map(function (z) { var zz = esc(z); return '<button type="button" class="bb-f-sz" data-f-sz="' + zz + '" aria-pressed="false">' + zz + '</button>'; }).join('') + '</div>' : '') +
          '<p class="bb-f-q">Where are you?</p>' +
          '<div class="bb-f-where">' +
            '<button type="button" class="bb-t-search">' + IC_LOC + 'SEARCH STORES NEAR ME</button>' +
            '<div class="bb-f-or">or</div>' +
            '<form class="bb-f-pin" data-f-pinform><input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="postal-code" placeholder="Enter PIN code" aria-label="PIN code" data-f-pin><button type="submit">Go</button></form>' +
          '</div>' +
          '<div class="bb-f-res" data-f-res></div>' +
        '</div></div>';
      var delPane = wrap.querySelector('[data-p="del"]');
      if (pin) { pin.parentNode.insertBefore(wrap, pin); delPane.appendChild(pin); }   // tabs where delivery was; move delivery in
      else { delPane.innerHTML = '<div class="bb-t-msg">Delivery details load below.</div>'; }
      wrap.hidden = false;

      wrap.querySelectorAll('.bb-t-tab').forEach(function (t) {
        t.onclick = function () {
          wrap.querySelectorAll('.bb-t-tab').forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          wrap.querySelectorAll('.bb-t-pane').forEach(function (p) { p.hidden = (p.getAttribute('data-p') !== t.getAttribute('data-t')); });
        };
      });

      var res = wrap.querySelector('[data-f-res]'), btn = wrap.querySelector('.bb-t-search'), pinIn = wrap.querySelector('[data-f-pin]');
      // Nothing loads until he gives a size AND a place (no IP guess — his rule, 12 Oct 2026).
      function paint() {
        if (HAS_SIZES && !fSize) { res.innerHTML = '<div class="bb-f-wait">Pick a size to see stores</div>'; return; }
        if (!fLoc) { res.innerHTML = '<div class="bb-f-wait">Tap “Search stores near me” or enter your PIN code</div>'; return; }
        if (fBusy) { res.innerHTML = '<div class="bb-f-wait">Finding stores near you…</div>'; return; }
        if (!fData) return;
        if (fData._err) { res.innerHTML = '<div class="bb-t-msg">' + fData._err + '</div>'; return; }
        res.innerHTML = decide(fData, fSize);
        fisRefresh();   // rows are new: each WhatsApp button goes live with his size
      }
      function load() {
        if ((HAS_SIZES && !fSize) || !fLoc) { paint(); return; }
        fBusy = true; fData = null; paint();
        var q = W + '/api/item.json?item=' + encodeURIComponent(ITEM) + '&code=' + (HAS_SIZES ? '&size=' + encodeURIComponent(upSize(fSize)) : '') +
          (fLoc.pin ? '&pin=' + fLoc.pin : '&lat=' + fLoc.lat + '&lng=' + fLoc.lng);
        var asked = fLoc;
        fetch(q).then(function (r) { return r.json(); }).then(function (d) {
          if (asked !== fLoc) return;   // he changed place meanwhile
          fBusy = false;
          // a PIN the store service can't place (or one it doesn't read yet) must never fall back to a guessed city
          if (fLoc.pin && d.pinFound !== true) fData = { _err: 'We couldn’t find PIN code ' + esc(fLoc.pin) + '. Check it, or tap “Search stores near me”.' };
          else fData = d;
          paint();
        }).catch(function () { if (asked !== fLoc) return; fBusy = false; fData = { _err: 'Could not load stores. Please try again.' }; paint(); });
      }
      // a size already picked on the page is picked here too (and this one follows it)
      function syncSize(z) {
        if (!HAS_SIZES) return;
        z = upSize(z); if (!z || SIZES.map(upSize).indexOf(z) < 0) return;
        fSize = z;
        wrap.querySelectorAll('[data-f-sz]').forEach(function (b) { var on = upSize(b.getAttribute('data-f-sz')) === z; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      syncSize(selectedSize());
      paint();
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-f-sz]');
        if (b) { syncSize(b.getAttribute('data-f-sz')); load(); return; }
        var buy = e.target.closest && e.target.closest('[data-f-buy],[data-f-add]');
        if (buy) {   // pick that size on the page; "Add to bag" also presses Add to cart
          var z = buy.getAttribute('data-f-buy') || buy.getAttribute('data-f-add');
          var pill = z && document.querySelector('[data-bpdp-ab-size][data-size="' + z.replace(/"/g, '') + '"]');
          if (pill) pill.click();
          if (buy.hasAttribute('data-f-add')) { var add = document.getElementById('bpdp-atc') || document.querySelector('[data-bpdp-ab-add]'); if (add) { add.click(); return; } }
          var sw = document.querySelector('.bpdp-absize') || pill; if (sw) try { sw.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
          return;
        }
        var nt = e.target.closest && e.target.closest('[data-f-notify]');
        if (nt) { var oos = document.querySelector('[data-bpdp-ab-oos][data-size="' + nt.getAttribute('data-f-notify').replace(/"/g, '') + '"]'); if (oos) oos.click(); return; }
        if (e.target.closest && e.target.closest('[data-f-sizes]')) { var fs = wrap.querySelector('.bb-f-sizes'); if (fs) try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {} }
      });
      // a size tapped on the page itself
      document.addEventListener('click', function (e) {
        var p = e.target.closest && e.target.closest('[data-bpdp-ab-size]');
        if (p) setTimeout(function () { var z = selectedSize(); if (z && z !== fSize) { syncSize(z); load(); } }, 60);
      });
      wrap.querySelector('[data-f-pinform]').addEventListener('submit', function (e) {
        e.preventDefault();
        var v = String(pinIn.value || '').replace(/\D/g, '');
        if (!/^[1-9]\d{5}$/.test(v)) { res.innerHTML = '<div class="bb-t-msg">Please enter a 6-digit PIN code.</div>'; return; }
        try { pinIn.blur(); } catch (_) {}
        fLoc = { pin: v }; load();
      });
      btn.onclick = function () {
        if (!navigator.geolocation) { res.innerHTML = '<div class="bb-t-msg">Location is not available here. Please enter your PIN code.</div>'; return; }
        btn.disabled = true; fLoc = null; fBusy = false; res.innerHTML = '<div class="bb-f-wait">Finding stores near you…</div>';
        navigator.geolocation.getCurrentPosition(function (pos) {
          btn.disabled = false;
          fLoc = { lat: (+pos.coords.latitude).toFixed(5), lng: (+pos.coords.longitude).toFixed(5) }; load();
        }, function () { btn.disabled = false; res.innerHTML = '<div class="bb-t-msg">Your phone didn’t share its location. Please enter your PIN code instead.</div>'; },
        { enableHighAccuracy: false, timeout: 9000, maximumAge: 600000 });
      };
    })();
  }
})();
